module.exports = __webpack_public_path__ + "static/img/Sela.4869bb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/Sela.png
// module id = Y7R/
// module chunks = 34